import { Utilities } from "./implementations/utilities.service"

export default defineNuxtPlugin((nuxtApp) => {
  const isDev = process.env.NODE_ENV === "development";

  return {
    provide: {
      utils: new Utilities({ isDev }),
    },
  };
});
